'use strict';

module.exports = {
  template: '',
  controller: require('./auth-logout.controller'),
  controllerAs: 'vm'
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/auth-logout/index.js
 ** module id = 174
 ** module chunks = 0
 **/